<template>
  <div class="footer">
    <div style="width:33%" />
    <div class="copyright">
      Copyright {{year}} Rayner 
    </div>
    <div class="links" v-if="!isQuestionnaire">
      <a target="blank" href="https://www.rayner.com/raypro/support">Support</a>
      <span class="separator">|</span>
      <a target="blank" href="https://www.rayner.com/raypro/privacy">Privacy</a>
      <span class="separator">|</span>
      <a target="blank" href="https://www.rayner.com/raypro/terms">Terms</a>
      <!-- <span class="separator">|</span>
      <a target="blank" href="www.rayner.com/raypro/cookies">Cookies</a> -->
    </div>
    <div class="links" v-else>
      <a target="blank" :href="patientPrivacyUrl">{{ patientPrivacyUrlLabel }}</a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['patientPrivacyUrl', 'patientPrivacyUrlLabel']),
    year() {
      return (new Date()).getFullYear()
    },
    isQuestionnaire() {
      if(this.$route && this.$route.name === 'patient-questionnaire-unauth') {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .footer
    color: $color-text-invert
    text-align: center
    margin: 10px 0 6px

    @include media($media-medium)
      display: flex
      justify-content: space-between
      padding: 1rem 4rem 1rem 4rem
      margin: 0 0 6px

    .links
      font-size: 14px
      //margin: 20px 0
      width: auto
      text-align: center
      margin-top: 10px

      @include media($media-medium)
        //margin: 0
        width: 33%
        text-align: right

      .separator
        margin: 0 1rem

    .copyright
      font-size: 12px
      width: auto
      align-self: center
      margin-top: 10px

      @include media($media-medium)
        width: 33%
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue